module.exports = __webpack_public_path__ + "img/slide9-img.d95de563.webp";